import React from 'react';

const SvgFj = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="FJ_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="FJ_svg__c">
        <stop stopColor="#042C90" offset="0%" />
        <stop stopColor="#00247E" offset="100%" />
      </linearGradient>
      <path
        d="M0 4.667V0h6.667v4.667c0 3.333-3.334 4.666-3.334 4.666S0 8 0 4.667z"
        id="FJ_svg__d"
      />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="FJ_svg__f">
        <stop stopColor="#FFF" offset="0%" />
        <stop stopColor="#F0F0F0" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="FJ_svg__b" fill="#fff">
        <use xlinkHref="#FJ_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#FJ_svg__a" />
      <path fill="#79CFF6" mask="url(#FJ_svg__b)" d="M0 0h28v20H0z" />
      <path
        fill="url(#FJ_svg__c)"
        mask="url(#FJ_svg__b)"
        d="M0 0h12v9.333H0z"
      />
      <g mask="url(#FJ_svg__b)">
        <g transform="translate(17.333 5.333)">
          <mask id="FJ_svg__e" fill="#fff">
            <use xlinkHref="#FJ_svg__d" />
          </mask>
          <use fill="#FFF" xlinkHref="#FJ_svg__d" />
          <path
            d="M1.333 3.333a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333zm4 0a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333z"
            fill="#2A915C"
            mask="url(#FJ_svg__e)"
          />
          <path
            fill="#EB1D43"
            mask="url(#FJ_svg__e)"
            d="M0 0h6.667v1.333H4V4h2.667v1.333H4v4H2.667v-4H0V4h2.667V1.333H0z"
          />
        </g>
      </g>
      <path
        d="M4.333 4.153L-.9-.333H.667l.193.062L5.44 3h1.131l5.762-3.601v.934c0 .296-.17.627-.417.803l-4.25 3.036V5.18l4.3 3.685c.377.323.185.802-.3.802-.257 0-.588-.107-.804-.261L6.56 6.333H5.429L-.333 9.935v-1.44l4.666-3.333V4.153z"
        stroke="#FFF"
        strokeWidth={0.667}
        fill="#DB1E36"
        mask="url(#FJ_svg__b)"
      />
      <path
        d="M0 3.333V6h4.667v3.34c0 .364.306.66.673.66h1.32a.67.67 0 0 0 .673-.66V6h4.658a.677.677 0 0 0 .676-.673v-1.32a.674.674 0 0 0-.676-.674H7.333V0H4.667v3.333H0z"
        fill="url(#FJ_svg__f)"
        mask="url(#FJ_svg__b)"
      />
      <path
        fill="#DB1E36"
        mask="url(#FJ_svg__b)"
        d="M0 4h5.333V0h1.334v4H12v1.333H6.667v4H5.333v-4H0z"
      />
    </g>
  </svg>
);

export default SvgFj;
